<template>
  <v-container class="pb-0">
    <v-row>
      <v-col md="4" sm="12" cols="12">
        <v-text-field
          v-model="filters.text"
          :label="$t('common.text')"
          solo
          dense
        ></v-text-field>
      </v-col>
      <v-col md="2" sm="12" cols="12">
        <v-select
          v-model="filters.type"
          :items="types"
          :label="$t('common.selectTypes')"
          solo
          dense
        ></v-select>
      </v-col>
      <v-col md="2" sm="12" cols="12">
        <v-select
          v-model="filters.status"
          :items="statuses"
          :label="$t('common.selectStatus')"
          solo
          dense
        ></v-select>
      </v-col>
      <v-col md="2" cols="12">
        <v-btn color="default" block @click="reset()">
          {{ $t('common.reset') }}
        </v-btn>
      </v-col>
      <v-col md="2" cols="12">
        <v-btn color="primary" block @click="filter()">
          {{ $t('common.filter') }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import approvalStatuses from '../../../enums/approval.statuses';
import questionTypes from '../../../enums/question.types';
import listFilterMixin from '../../shared/mixins/list.filter.mixin';

export default {
  name: 'questions-list-filter',
  mixins: [listFilterMixin],
  data() {
    return {
      defaultFilters: {
        text: null,
        status: null
      },
      types: [
        {
          text: this.$i18n.t('common.selectTypes'),
          value: ''
        },
        ...Object.values(questionTypes)
      ],
      statuses: [
        {
          text: this.$i18n.t('common.selectStatus'),
          value: ''
        },
        ...Object.values(approvalStatuses).map(status => ({
          text: this.$i18n.t(`common.approvalStatuses.${status}`),
          value: status
        }))
      ]
    };
  }
};
</script>
